import { createRouter, createWebHistory } from "vue-router";

import store from "../store";
import OuterLayout from "../layouts/OuterLayout.vue";
import MainLayout from "../layouts/MainLayout2.vue";
import Register from "../views/Auth/Register.vue";
import Login from "../views/Auth/Login.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import Dashboard from "../views/Pages/Dashboard.vue";
import HTEDashboard from "../views/Pages/HTEDashboard.vue";
import CoordinatorDashboard from "../views/Pages/CoordinatorDashboard.vue";
import ProgramChairDashboard from "../views/Pages/ProgramChairDashboard.vue";
import InstructorDashboard from "../views/Pages/InstructorDashboard.vue";
// import EmployeeDashboard from "../views/Pages/EmployeeDashboard.vue";
import Profile from "../views/Pages/Profile.vue";
import RegisterSuccess from "../views/Auth/RegisterSuccess.vue";
import UserType from "../views/Pages/UserType.vue";
import AccountVerification from "../views/Pages/AccountVerification.vue";
import Users from "../views/Pages/Users.vue";
import UserModules from "../views/Pages/UserModules.vue";
import ModulesList from "../views/Pages/ModulesList.vue";
import NotFound from "../views/Pages/NotFound.vue";
import DSS from "../views/Pages/DSS.vue";
import DSSCriterion from "../views/Pages/DSSCriterion.vue";
import OJTOrgs from "../views/Pages/OJTOrgs.vue";
import Student from "../views/Pages/Student.vue";
import StudentRequirements from "@/views/Pages/StudentRequirements.vue";
import StudentDashboard from "@/views/Pages/StudentDashboard.vue";
import StudentRequirementSubmission from "@/views/Pages/StudentRequirementSubmission.vue";
import StudentSubmissions from "@/views/Pages/StudentSubmissions.vue";
import StudentSubmissionUtil from "@/views/Pages/StudentSubmissionUtil.vue";
import Programs from "@/views/Pages/Programs.vue";
import StudentToOrgMatching from "@/views/Pages/StudentToOrgMatching.vue";
import OJTInstructor from "@/views/Pages/OJTInstructor.vue";
import SkillsAssessment from "@/views/Pages/SkillsAssessment.vue";
import StudentSkillsAssessment from "@/views/Pages/StudentSkillsAssessment.vue";
import MultiModule from "@/views/Pages/MultiModule.vue";
import StudentProfilePage from "@/views/Pages/StudentProfilePage.vue";
import Profiling from "@/views/Pages/Profiling.vue";
import StudentFindHTE from "@/views/Pages/StudentFindHTE.vue";
import StudentAttendance from "@/views/Pages/StudentAttendance.vue";
import CompanyProfile from "@/views/Pages/CompanyProfile.vue";
import CompanyQRAttendance from "@/views/Pages/CompanyQRAttendance.vue";
import CompanyFindIntern from "@/views/Pages/CompanyFindIntern.vue";
import ManageIntern from "@/views/Pages/ManageIntern.vue";
import InternEvaluation from "@/views/Pages/InternEvaluation.vue";
import RequestIntern from "@/views/Pages/RequestIntern.vue";
import HTEInternRequest from "@/views/Pages/HTEInternRequest.vue";
import UserManagement from "@/views/Pages/UserManagement.vue";
import MonitorStudent from "@/views/Pages/MonitorStudent.vue";
import MonitorStudentDetail from "@/views/Pages/MonitorStudentDetail.vue";
import StudentCoretime from "@/views/Pages/StudentCoretime.vue";
import FieldOfficer from "@/views/Pages/FieldOfficer.vue";
import ChangePass from "@/views/Pages/ChangePass.vue";
import AssignRoles from "@/views/Pages/AssignRoles.vue";
import CoordinatorOJTPartner from "@/views/Pages/CoordinatorOJTPartner.vue";
import MoaAndAgreements from "@/views/Pages/MoaAndAgreements.vue";
import DeanDashboard from "@/views/Pages/DeanDashboard.vue";
import VPAADashboard from "@/views/Pages/VPAADashboard.vue";
import AttendanceUploading from "@/views/Pages/AttendanceUploading.vue";
import PreferredSkills from "@/views/Pages/PreferredSkills.vue";
import InternCoretimeApproval from "@/views/Pages/InternCoretimeApproval.vue";
import StudentEvaluation from "@/views/Pages/StudentEvaluation.vue";
import CompanyInternFeedback from "@/views/Pages/CompanyInternFeedback.vue";
import InternFeedback from "@/views/Pages/InternFeedback.vue";
import PreferredOJTLocation from "@/views/Pages/PreferredOJTLocation.vue";
import ActivityLog from "@/views/Pages/ActivityLog.vue";
import StudentPracticumAttendance from "@/views/Pages/StudentPracticumAttendance.vue";
const routes = [
  {
    path: "/",
    component: OuterLayout,
    redirect: "/login",
    meta: { authRequired: false },
    children: [
      {
        path: "login",
        alias: "/login",
        component: Login,
        meta: { authRequired: false },
      },
      {
        path: "register",
        component: Register,
        meta: { authRequired: false },
      },
      {
        path: "registration-success",
        component: RegisterSuccess,
        meta: { authRequired: false },
      },

      {
        path: "forgot-pw",
        component: ResetPassword,
        meta: { authRequired: false },
      },
    ],
  },
  // vpaa
  {
    path: "/vpaa",
    redirect: "/vpaa/dashboard",
    meta: { authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: VPAADashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
    meta: { authRequired: false },
  },
  //admin
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: Dashboard,
        meta: { title: "Dashboard", authRequired: true },
      },

      {
        path: "acc_verify",
        component: AccountVerification,
        meta: { title: "Account Verification", authRequired: true },
      },

      {
        path: "user-type",
        component: UserType,
        meta: { title: "Utilities - Type of Users", authRequired: true },
      },
      {
        path: "profile",
        component: Profile,
        meta: { title: "My Profile", authRequired: true },
      },

      {
        path: "modules-list",
        component: ModulesList,
        meta: { title: "List of Modules", authRequired: true },
      },

      {
        path: "user-modules",
        component: UserModules,
        meta: { title: "User Modules", authRequired: true },
      },

      {
        path: "users",
        component: Users,
        name: "UserPage",
        meta: { title: "Utilities - Users", authRequired: true },
      },
      {
        path: "dss",
        component: DSS,
        name: "DSS",
        meta: { title: "Decision Support", authRequired: true },
      },
      {
        path: "dss-criterion",
        component: DSSCriterion,
        name: "DSS Criterion",
        meta: { title: "Decision Support Criterion", authRequired: true },
      },
      {
        path: "ojt-orgs",
        component: OJTOrgs,
        name: "OJT Organizations",
        meta: { title: "OJT Organizations", authRequired: true },
      },

      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
      // {
      //   path: "404",
      //   component: NotFound,
      //   meta: { authRequired: true },
      // },
    ],
  },
  //superadmin]
  {
    path: "/superadmin",
    redirect: "/superadmin/dashboard",
    meta: { RouteForSuperAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: Dashboard,
        meta: { title: "Dashboard", authRequired: true },
      },

      {
        path: "user-type",
        component: UserType,
        meta: { title: "Utilities - Type of Users", authRequired: true },
      },
      {
        path: "profile",
        component: Profile,
        meta: { title: "My Profile", authRequired: true },
      },
      {
        path: "user-modules",
        component: UserModules,
        meta: { title: "User Modules", authRequired: true },
      },
      {
        path: "modules-list",
        component: ModulesList,
        meta: { title: "List of Modules", authRequired: true },
      },
      {
        path: "acc_verify",
        component: AccountVerification,
        meta: { title: "Account Verification", authRequired: true },
      },

      {
        path: "user-management",
        component: UserManagement,
        meta: { title: "Users Management", authRequired: true },
      },

      {
        path: "programs",
        component: Programs,
        meta: { title: "Programs", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
    ],
  },
  //org
  {
    path: "/organization",
    redirect: "/organization/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: HTEDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "profile",
        component: CompanyProfile,
        meta: { title: "Company Profile", authRequired: true },
      },
      {
        path: "attendance-qr",
        component: CompanyQRAttendance,
        meta: { title: "Attendance", authRequired: true },
      },
      {
        path: "find-interns",
        component: CompanyFindIntern,
        meta: { title: "Find Interns", authRequired: true },
      },
      {
        path: "manage-intern",
        component: ManageIntern,
        meta: { title: "Manage Interns", authRequired: true },
      },
      {
        path: "intern-evaluations",
        component: InternEvaluation,
        meta: { title: "Intern Evaluation", authRequired: true },
      },
      {
        path: "request-intern",
        component: RequestIntern,
        meta: { title: "Request Interns", authRequired: true },
      },

      {
        path: "field-officers",
        component: FieldOfficer,
        meta: { title: "Field Officers", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },

      {
        path: "core-time-approval",
        component: InternCoretimeApproval,
        meta: { title: "Intern Coretime Approval", authRequired: true },
      },

      {
        path: "intern-feedback",
        component: CompanyInternFeedback,
        meta: { title: "Intern Feedback", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
    ],
  },
  //instructor
  {
    path: "/instructor",
    redirect: "/instructor/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: InstructorDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "students",
        component: Student,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "profile",
        component: Profile,
        meta: { title: "My Profile", authRequired: true },
      },
      {
        path: "ojt-orgs",
        component: OJTOrgs,
        name: "OJT Organizations",
        meta: { title: "OJT Organizations", authRequired: true },
      },
      {
        path: "dss-criterion",
        component: DSSCriterion,
        name: "DSS Criterion",
        meta: { title: "Decision Support Criterion", authRequired: true },
      },
      {
        path: "student-requirements",
        component: StudentRequirements,
        name: "Student Requirements",
        meta: { title: "Student Requirements", authRequired: true },
      },
      {
        path: "student-submission-util",
        component: StudentSubmissionUtil,
        name: "Student Submission Utility",
        meta: { title: "Student Submission Utility", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },

      {
        path: "practicum-attendance",
        component: StudentPracticumAttendance,
        meta: { title: "Practicum Attendance", authRequired: true },
      },
    ],
  },
  //dean
  {
    path: "/dean",
    redirect: "/dean/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: DeanDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "monitor-students",
        component: MonitorStudent,
        meta: { title: "Monitor Students", authRequired: true },
      },
      {
        path: "monitor-students/:id",
        component: MonitorStudentDetail,
        name: "dean-monitor-student-detail",
        meta: { title: "Student Details", authRequired: true },
      },
      {
        path: "assign-role",
        component: AssignRoles,
        meta: { title: "Assign Role", authRequired: true },
      },
      {
        path: "ojt-orgs",
        component: OJTOrgs,
        name: "OJT Organizations",
        meta: { title: "OJT Organizations", authRequired: true },
      },
      {
        path: "moa-agreements",
        component: MoaAndAgreements,
        name: "MOAs and Agreements",
        meta: { title: "MOAs and Agreements", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
    ],
  },
  //student
  {
    path: "/student",
    redirect: "/student/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: StudentDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },

      {
        path: "my-requirements",
        component: StudentRequirementSubmission,
        meta: { title: "My Requirements", authRequired: true },
      },
      {
        path: "submissions",
        component: StudentSubmissions,
        meta: { title: "My Submissions", authRequired: true },
      },
      {
        path: "profile",
        component: StudentProfilePage,
        meta: { title: "My Profile", authRequired: true },
      },
      {
        path: "skills-assessment",
        component: StudentSkillsAssessment,
        name: "Student Skills Assessment",
        meta: { title: "SkillsAssessment", authRequired: true },
      },
      {
        path: "profiling",
        component: Profiling,
        meta: { title: "Profile Form", authRequired: true },
      },

      {
        path: "find-hte",
        component: StudentFindHTE,
        meta: { title: "HTE's", authRequired: true },
      },
      {
        path: "my-attendances",
        component: StudentAttendance,
        meta: { title: "My Attendances", authRequired: true },
      },
      {
        path: "my-coretime",
        component: StudentCoretime,
        meta: { title: "My Coretime", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
    ],
  },
  //ojt coordinator
  {
    path: "/ojt-coordinator",
    redirect: "/ojt-coordinator/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: CoordinatorDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "students",
        component: Student,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "profile",
        component: Profile,
        meta: { title: "My Profile", authRequired: true },
      },
      // {
      //   path: "ojt-orgs",
      //   component: OJTOrgs,
      //   name: "OJT Organizations",
      //   meta: { title: "OJT Organizations", authRequired: true },
      // },
      {
        path: "ojt-orgs",
        component: CoordinatorOJTPartner,
        name: "OJT asdasdOrganizations",
        meta: { title: "OJT Organizations", authRequired: true },
      },
      {
        path: "dss-criterion",
        component: DSSCriterion,
        name: "DSS Criterion",
        meta: { title: "Decision Support Criterion", authRequired: true },
      },
      {
        path: "student-requirements",
        component: StudentRequirements,
        name: "Student Requirements",
      },
      {
        path: "student-submission-util",
        component: StudentSubmissionUtil,
        name: "Student Submission Utility",
        meta: { title: "Student Submission Utility", authRequired: true },
      },
      {
        path: "student-to-org-matching",
        component: StudentToOrgMatching,
        name: "Student to Organization Matching",
        meta: { title: "Student to Organization Matching", authRequired: true },
      },
      {
        path: "ojt-instructor",
        component: OJTInstructor,
        name: "OJT Instructor",
        meta: { title: "OJT Instructor", authRequired: true },
      },
      {
        path: "skills-assessment",
        component: SkillsAssessment,
        name: "Skills Assessment",
        meta: { title: "Skills Assessment", authRequired: true },
      },
      {
        path: "module",
        component: MultiModule,
        name: "Modules",
        meta: { title: "Modules", authRequired: true },
      },
      {
        path: "hte-intern-request",
        component: HTEInternRequest,
        name: "HTE Intern Request",
        meta: { title: "HTE Intern Request", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
      {
        path: "attendance-upload",
        component: AttendanceUploading,
        meta: { title: "Attendance Uploading", authRequired: true },
      },
      {
        path: "preferred-skills",
        component: PreferredSkills,
        meta: { title: "Preferred Skills Utility", authRequired: true },
      },
      {
        path: "preferred-ojt-location",
        component: PreferredOJTLocation,
        meta: { title: "Preferred OJT Location Utility", authRequired: true },
      },
      {
        path: "student-evaluation",
        component: StudentEvaluation,
        name: "Student Evaluations",
        meta: { title: "Student Evaluations", authRequired: true },
      },
      {
        path: "hte-feedback",
        component: InternFeedback,
        meta: { title: "HTE's Intern Feedback", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "practicum-attendance",
        component: StudentPracticumAttendance,
        meta: { title: "Practicum Attendance", authRequired: true },
      },
    ],
  },
  //field-officer
  {
    path: "/field-officer",
    redirect: "/field-officer/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: HTEDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "profile",
        component: CompanyProfile,
        meta: { title: "Company Profile", authRequired: true },
      },
      {
        path: "attendance-qr",
        component: CompanyQRAttendance,
        meta: { title: "Attendance", authRequired: true },
      },
      {
        path: "find-interns",
        component: CompanyFindIntern,
        meta: { title: "Find Interns", authRequired: true },
      },
      {
        path: "manage-intern",
        component: ManageIntern,
        meta: { title: "Manage Interns", authRequired: true },
      },
      {
        path: "intern-evaluations",
        component: InternEvaluation,
        meta: { title: "Intern Evaluation", authRequired: true },
      },
      {
        path: "request-intern",
        component: RequestIntern,
        meta: { title: "Request Interns", authRequired: true },
      },

      {
        path: "field-officers",
        component: FieldOfficer,
        meta: { title: "Field Officers", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },

      {
        path: "core-time-approval",
        component: InternCoretimeApproval,
        meta: { title: "Intern Coretime Approval", authRequired: true },
      },
      {
        path: "intern-feedback",
        component: CompanyInternFeedback,
        meta: { title: "Intern Feedback", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
    ],
  },
  //Program chairperson
  {
    path: "/program-chair",
    redirect: "/program-chair/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        component: ProgramChairDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "monitor-students",
        component: MonitorStudent,
        meta: { title: "Monitor Students", authRequired: true },
      },
      {
        path: "monitor-students/:id",
        component: MonitorStudentDetail,
        name: "monitor-student-detail",
        meta: { title: "Student Details", authRequired: true },
      },
      {
        path: "assign-role",
        component: AssignRoles,
        meta: { title: "Assign Role", authRequired: true },
      },
      {
        path: "students",
        component: Student,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "profile",
        component: Profile,
        meta: { title: "My Profile", authRequired: true },
      },
      // {
      //   path: "ojt-orgs",
      //   component: OJTOrgs,
      //   name: "OJT Organizations",
      //   meta: { title: "OJT Organizations", authRequired: true },
      // },
      {
        path: "ojt-orgs",
        component: CoordinatorOJTPartner,
        name: "OJT asdasdOrganizations",
        meta: { title: "OJT Organizations", authRequired: true },
      },
      {
        path: "dss-criterion",
        component: DSSCriterion,
        name: "DSS Criterion",
        meta: { title: "Decision Support Criterion", authRequired: true },
      },
      {
        path: "student-requirements",
        component: StudentRequirements,
        name: "Student Requirements",
      },
      {
        path: "student-submission-util",
        component: StudentSubmissionUtil,
        name: "Student Submission Utility",
        meta: { title: "Student Submission Utility", authRequired: true },
      },
      {
        path: "student-to-org-matching",
        component: StudentToOrgMatching,
        name: "Student to Organization Matching",
        meta: { title: "Student to Organization Matching", authRequired: true },
      },
      {
        path: "ojt-instructor",
        component: OJTInstructor,
        name: "OJT Instructor",
        meta: { title: "OJT Instructor", authRequired: true },
      },
      {
        path: "skills-assessment",
        component: SkillsAssessment,
        name: "Skills Assessment",
        meta: { title: "Skills Assessment", authRequired: true },
      },
      {
        path: "module",
        component: MultiModule,
        name: "Modules",
        meta: { title: "Modules", authRequired: true },
      },
      {
        path: "hte-intern-request",
        component: HTEInternRequest,
        name: "HTE Intern Request",
        meta: { title: "HTE Intern Request", authRequired: true },
      },
      {
        path: "change-creds",
        component: ChangePass,
        meta: { title: "Change Password", authRequired: true },
      },
      {
        path: "attendance-upload",
        component: AttendanceUploading,
        meta: { title: "Attendance Uploading", authRequired: true },
      },
      {
        path: "preferred-skills",
        component: PreferredSkills,
        meta: { title: "Preferred Skills Utility", authRequired: true },
      },
      {
        path: "preferred-ojt-location",
        component: PreferredOJTLocation,
        meta: { title: "Preferred OJT Location Utility", authRequired: true },
      },
      {
        path: "student-evaluation",
        component: StudentEvaluation,
        name: "Student Evaluations",
        meta: { title: "Student Evaluations", authRequired: true },
      },
      {
        path: "hte-feedback",
        component: InternFeedback,
        meta: { title: "HTE's Intern Feedback", authRequired: true },
      },
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true },
      },
      {
        path: "practicum-attendance",
        component: StudentPracticumAttendance,
        meta: { title: "Practicum Attendance", authRequired: true },
      },
    ],
  },
];

// const router = new createRouter({
//   mode: "history",
// base: process.env.BASE_URL,
//   routes,
// });
const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // let user = store.state.user;
  const isAuthenticated = store.getters.getIsAuthenticated;
  if (to.matched.some((record) => record.meta.authRequired == true)) {
    if (isAuthenticated) {
      let pt = to.fullPath;
      let ptSplit = pt.split("/");

      if (store.state.user.user.usertypeID == 1) {
        if (ptSplit[1].toLowerCase() == "superadmin") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/superadmin/change-creds") {
              next("/superadmin/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/superadmin/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/superadmin/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 2) {
        if (ptSplit[1].toLowerCase() == "admin") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/admin/change-creds") {
              next("/admin/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/admin/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/admin/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 3) {
        if (ptSplit[1].toLowerCase() == "ojt-coordinator") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/ojt-coordinator/change-creds") {
              next("/ojt-coordinator/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/ojt-coordinator/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/ojt-coordinator/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 4) {
        if (ptSplit[1].toLowerCase() == "instructor") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/instructor/change-creds") {
              next("/instructor/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/instructor/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/instructor/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 5) {
        if (ptSplit[1].toLowerCase() == "dean") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/dean/change-creds") {
              next("/dean/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/dean/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/dean/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 6) {
        if (ptSplit[1].toLowerCase() == "vpaa") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/vpaa/change-creds") {
              next("/vpaa/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/vpaa/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/vpaa/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 7) {
        if (ptSplit[1].toLowerCase() == "organization") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/organization/change-creds") {
              next("/organization/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/organization/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/admin/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 8) {
        if (ptSplit[1].toLowerCase() == "student") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/student/change-creds") {
              next("/student/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/student/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/student/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 9) {
        if (ptSplit[1].toLowerCase() == "field-officer") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/field-officer/change-creds") {
              next("/field-officer/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/field-officer/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/field-officer/dashboard");
        }
      } else if (store.state.user.user.usertypeID == 10) {
        if (ptSplit[1].toLowerCase() == "program-chair") {
          if (store.state.user.user.isFirstTimeLogin == 1) {
            if (to.path !== "/program-chair/change-creds") {
              next("/program-chair/change-creds");
            } else {
              next();
            }
          } else {
            if (!to.matched.length) {
              next("/program-chair/dashboard");
            } else {
              next();
            }
          }
        } else {
          next("/program-chair/dashboard");
        }
      }
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
